import gql from 'graphql-tag';

export default gql`
  fragment actionContractFragment on ActionContract {
    id
    userRoleCanTaskList
    userRoleCanApproachList
  }
`;
